module.exports = __webpack_public_path__ + "static/template-preview-f9ae6d93926e459d185ea60149372a4a.png";